import React, { useEffect, useState } from 'react';
import { Phone, Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'Why Us',
    href: '#why-us'
  }, {
    name: 'Service Area',
    href: '#service-area'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-2' : 'bg-transparent py-4'}`} data-id="element-181">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-182">
        <div className="flex justify-between items-center" data-id="element-183">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-184">
            <a href="#" className="flex items-center gap-2" data-id="element-185">
              <img src="https://cdn.magicpatterns.com/uploads/64Tmnvawd7bSgaucnVbdbX/d9a147a9-aeff-42e4-941e-cfb023a07271-Photoroom.png" alt="I&A Landscaping Logo" className={`transition-all duration-300 ${isScrolled ? 'h-12' : 'h-16'} object-contain brightness-0 ${isScrolled ? 'invert-0' : 'invert'}`} data-id="element-186" />
              <span className={`font-serif font-bold text-xl tracking-wide ${isScrolled ? 'text-[#1B4332]' : 'text-white'}`} data-id="element-187">
                I&A LANDSCAPING
              </span>
            </a>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-188">
            {navLinks.map(link => <a key={link.name} href={link.href} className={`font-medium transition-colors hover:text-[#D4A373] ${isScrolled ? 'text-gray-800' : 'text-white'}`} data-id="element-189">
                {link.name}
              </a>)}
            <a href="tel:4402221065" className="flex items-center gap-2 bg-[#C41E24] hover:bg-[#a8181e] text-white px-6 py-2.5 rounded-full font-semibold transition-colors shadow-lg" data-id="element-190">
              <Phone size={18} data-id="element-191" />
              <span data-id="element-192">(440) 222-1065</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-193">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className={`${isScrolled ? 'text-gray-800' : 'text-white'} hover:text-[#D4A373] focus:outline-none`} data-id="element-194">
              {isMobileMenuOpen ? <X size={28} data-id="element-195" /> : <Menu size={28} data-id="element-196" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden bg-white shadow-xl absolute top-full left-0 w-full border-t border-gray-100" data-id="element-197">
          <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-198">
            {navLinks.map(link => <a key={link.name} href={link.href} className="block px-3 py-3 text-base font-medium text-gray-800 hover:text-[#1B4332] hover:bg-gray-50 rounded-md" onClick={() => setIsMobileMenuOpen(false)} data-id="element-199">
                {link.name}
              </a>)}
            <a href="tel:4402221065" className="mt-4 flex items-center justify-center gap-2 bg-[#C41E24] text-white px-4 py-3 rounded-md font-semibold" data-id="element-200">
              <Phone size={18} data-id="element-201" />
              <span data-id="element-202">Call (440) 222-1065</span>
            </a>
          </div>
        </div>}
    </nav>;
}